import $ from "jquery";
import App from "../App";
import Api from "../App/Api";

const ReportMap = (() => {
  let map;
  let circle;
  let marker;
  let zoom = 0;
  const initializeMap = function ($element) {
    const maxBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(parseFloat($element.attr('data-bounds-sw-lat')), parseFloat($element.attr('data-bounds-sw-lng'))),
      new google.maps.LatLng(parseFloat($element.attr('data-bounds-ne-lat')), parseFloat($element.attr('data-bounds-ne-lng'))),
    );
    const minZoom = parseInt($element.attr('data-min-zoom'));
    const maxZoom = parseInt($element.attr('data-max-zoom'));
    zoom = parseInt($element.attr('data-zoom'));
    map = new google.maps.Map($element.get(0), {
      center: {
        lat: parseFloat($element.attr('data-lat')),
        lng: parseFloat($element.attr('data-lng'))
      },
      zoom: zoom,
      scrollwheel: false,
      streetViewControl: false,
      mapTypeControl: false,
      scaleControl: false,
      draggable: true,
      navigationControl: true,
      navigationControlOptions: {style: google.maps.NavigationControlStyle.SMALL},
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    });

    google.maps.event.addListener(map, 'drag', function () {
      if (maxBounds.contains(map.getCenter())) {
        return;
      }
      let c = map.getCenter(),
        x = c.lng(),
        y = c.lat(),
        maxX = maxBounds.getNorthEast().lng(),
        maxY = maxBounds.getNorthEast().lat(),
        minX = maxBounds.getSouthWest().lng(),
        minY = maxBounds.getSouthWest().lat();
      if (x < minX) {
        x = minX;
      }
      if (x > maxX) {
        x = maxX;
      }
      if (y < minY) {
        y = minY;
      }
      if (y > maxY) {
        y = maxY;
      }
      map.setCenter(new google.maps.LatLng(y, x));
    });

    google.maps.event.addListener(map, 'zoom_changed', function () {
      if (map.getZoom() < minZoom) {
        map.setZoom(minZoom);
      } else if (map.getZoom() > maxZoom) {
        map.setZoom(maxZoom);
      }
    });

    const $address = $('#address-select');
    $address.select2({
      language: 'de',
      minimumInputLength: 3,
      tags: false,
      allowClear: true,
      placeholder: "Straße...",
      ajax: {
        url: Api.getAddressFilterUrl(),
        dataType: 'json',
        type: "POST",
        delay: 100,
        quietMillis: 100,
        cache: true,
        data: function (term) {
          return {
            term: term
          };
        },
        results: function (data) {
          console.log(data);
          return {
            results: $.map(data, function (item) {
              return {
                text: item.address,
                id: item.id
              }
            })
          };
        }
      }
    });

    onAddressChanged($address);
    $address.change(function () {
      onAddressChanged($address);
    });

    const $content = $('#report-form-container');
    const $successMessage = $content.find('.success-message');
    let successMessage = '<b>Vielen Dank für Ihre Meldung.</b><br><br> Wir werden Ihr Anliegen schnellstmöglich ' +
      'bearbeiten. In Einzelfällen kann die Bearbeitung einige Tage in Anspruch nehmen. In diesem Zusammenhang sehen ' +
      'Sie bitte von weiteren Nachfragen ab. Danke für Ihr Verständnis.';
    if($successMessage.length) {
      successMessage = $successMessage.html();
    }
    const $form = $content.find('form');
    const $submit = $form.find('input[type=submit], button[type=submit]');
    const $messages = $content.find('.form-messages');
    const $errorElement = $('<div/>', {
      class: 'error',
      text: 'Ein Fehler aufgetreten. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'
    });
    const $errorElementImage = $('<div/>', {
      class: 'error',
      text: 'Bitte schreiben Sie einen Nachricht oder laden Sie ein Bild hoch!'
    });
    const $successElement = $('<div/>', {
      class: 'success',
    }).html(successMessage);
    $('#image-upload').fileinput({
      showUpload: false,
      language: 'de',
      theme: 'fa',
      async: false,
      required: false,
      ajax: $form.attr('action'),
      allowedFileExtensions: ['jpg', 'jpeg', 'gif', 'png']
    });
    $form.submit(function (e) {
      e.preventDefault();
      const formData = new FormData(this);
      $messages.empty();
      $submit.attr('disabled', true);
      $.ajax({
        type: $form.attr('method'),
        url: $form.attr('action'),
        data: formData,
        processData: false,
        contentType: false,
        cache: false
      }).done(function (response) {
        if (App.isJSONString(response)) {
          const data = JSON.parse(response);
          if (data.status === 1) {
            $messages.append($successElement);
            $form.slideUp();
          } else if (data.status === 2) {
            $messages.append($errorElementImage);
          }
        } else {
          $messages.append($errorElement);
        }
      }).fail(function () {
        $messages.append($errorElement);
      }).always(function () {
        $submit.removeClass('loading');
        $submit.attr('disabled', false);
      });
    });
  };

  const onAddressChanged = function ($address) {
    const geocoder = new google.maps.Geocoder();
    const address = $address.find('option[value=\'' + $address.val() + '\']').text();
    if (address.length > 0) {
      geocoder.geocode({'address': address + ', ' + App.Api.geoLocation + ', AT'}, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          setupMarker(results[0].geometry.location);
          map.setZoom(18);
        }
      });
    } else {
      map.setZoom(zoom);
    }
  };

  const setupMarker = function (center) {
    if (typeof circle !== 'undefined') {
      circle.setMap(null);
    }
    if (typeof marker !== 'undefined') {
      marker.setMap(null);
    }
    map.setCenter(center);
    circle = new google.maps.Circle({
      strokeColor: '#FF0000',
      strokeOpacity: 0.2,
      strokeWeight: 2,
      fillColor: '#FF0000',
      fillOpacity: 0.1,
      map: map,
      draggable: false,
      center: center,
      radius: 100
    });
    marker = new google.maps.Marker({
      map: map,
      draggable: true,
      animation: google.maps.Animation.DROP,
      position: circle.center
    });
    let prevPosition = circle.center;
    marker.addListener('dragend', function (event) {
      if (!circle.getBounds().contains(marker.position) || google.maps.geometry.spherical.computeDistanceBetween(circle.getCenter(), marker.position) > circle.getRadius()) {
        marker.setPosition(prevPosition);
      } else {
        prevPosition = marker.position;
      }
      event.latLng = marker.position;
      handleEvent(event);
    });
    marker.addListener('drag', handleEvent);
    handleEvent({latLng: marker.position});
  };

  const handleEvent = function (event) {
    $('.map-latitude').each(function (index, element) {
      const $element = $(element);
      if ($element.is('input')) {
        $element.val(event.latLng.lat())
      } else {
        $element.text(event.latLng.lat())
      }
    });
    $('.map-longitude').each(function (index, element) {
      const $element = $(element);
      if ($element.is('input')) {
        $element.val(event.latLng.lng())
      } else {
        $element.text(event.latLng.lng())
      }
    });
  };

  return {
    initialize: function (selector) {
      if (!App.isGoogleLoaded()) {
        return;
      }
      let isLoaded = false;
      const $window = $(window);
      const $map = $(selector);
      if ($map.length > 0) {
        const loadGoogleMap = function () {
          if (isLoaded) {
            return;
          }
          const windowOffset = (window.innerHeight ? window.innerHeight : $window.height()) + $window.scrollTop();
          if (windowOffset >= $map.offset().top - 300) {
            isLoaded = true;
            $window.off("load.gm resize.gm scroll.gm orientationchange.gm");
            initializeMap($map);
          }
        };
        $window.on("load.gm resize.gm scroll.gm orientationchange.gm", function (e) {
          loadGoogleMap();
        });
        loadGoogleMap();
      }
    },
  };
})();

module.exports = ReportMap;
